import script from "./LoginSigaaView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginSigaaView.vue?vue&type=script&setup=true&lang=js"

import "./LoginSigaaView.vue?vue&type=style&index=0&id=2302da40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2302da40"]])

export default __exports__